module.exports = __webpack_public_path__ + "img/ts_2008.47d558be.jpg";